import { PlayerEvent } from 'common/events/video-event-types'
import { ComponentEvent } from 'common/events/component-event'
import { ImageSourceWithCaptions } from 'common/client-data-types/image-item'
import { Topic } from 'common/client-data-types/topic'

import { PublicationType } from 'common/client-data-types/publication'
import { Profile } from 'common/client-data-types/Profile'
import { LayoutViewV4DTO } from 'publication-types'
import { SharingEvent } from '../events/share-events'

export type ClickableCardItems = string | CardItem | BreakingNewsCard

export interface CardClickedEventProps {
    cardItem: ClickableCardItems
    cardInfo: string
    cardNumber: number
    cardFormat:
        | 'Portrait'
        | 'Landscape'
        | 'InlineContent'
        | 'LandscapeStacked'
        | 'LandscapeWide'
        | 'List'
        | 'HeroCard'
        | 'Branded'
        | 'BreakingNews'
        | 'Announcement'
        | 'SevenNewsBreakingNews'
        | 'PromotionalCard'
        | 'ProfileCard'
}

export interface CardClickedEvent extends ComponentEvent<CardClickedEventProps> {
    type: 'card.clicked'
}

export type CardEvents = CardClickedEvent | PlayerEvent | SharingEvent

export interface PublicationCardItemWithoutVideo {
    cardType: 'publication'

    // content
    id: string
    headline: string
    shortHeadline: string
    link: string
    primaryTopic: Topic
    secondaryTopics: Topic[]
    kicker: string
    byline: string
    profiles?: Profile[]
    publicationKind: PublicationType['kind']
    source: string
    layoutView?: LayoutViewV4DTO

    teaser: string
    publicationDate?: string
    lastUpdated?: string

    // media
    image?: ImageSourceWithCaptions
    providerLogo?: string

    // status
    isLive: boolean
    isSponsored: boolean
    isPremium: boolean

    // number of images in gallery
    imageCount?: number

    // full url path to publication
    _self: string
}

export interface PublicationCardItemVideo {
    id: string
    accountId: string
    heading: string
    source: string | undefined
    duration: string | null
    videoType: 'vod' | 'live' | null
}

export interface PublicationCardItemWithVideo extends PublicationCardItemWithoutVideo {
    video: PublicationCardItemVideo
    provider?: string
    providerLogo?: string
}

export interface TheWestLivePromoTileCard {
    cardType: 'the-west-live-promo-tile'
}

export interface MarketingRedirectTileCard {
    cardType: 'marketing-redirect-tile'
    image: string
    url: string
    altText: string
}

export interface BreakingNewsCard {
    cardType: 'breaking-news'
    shortHeadline: string
    link: string
}

export type PublicationCardItem = PublicationCardItemWithoutVideo | PublicationCardItemWithVideo

export type CardItem = PublicationCardItem | MarketingRedirectTileCard | TheWestLivePromoTileCard

export function isPublicationCardItem(cardItem: CardItem): cardItem is PublicationCardItem {
    return cardItem.cardType === 'publication'
}
export function isPublicationCardItemWithVideo(
    cardItem: PublicationCardItemWithoutVideo
): cardItem is PublicationCardItemWithVideo {
    return 'video' in cardItem
}
